import createCache from "@emotion/cache"

// Shared emotion cache for MUI, used by both the browser runtime and the
// SSR critical-CSS extraction (see the project root gatsby-ssr.js).
//
// `prepend: true` inserts MUI's <style> tags at the very top of <head>,
// keeping them clustered away from react-helmet, which mutates the end of
// <head>. That separation prevents the production-only emotion
// `insertBefore` NotFoundError (white screen) that occurred when react-helmet
// removed a node emotion was using as its insertion anchor.
export default function createEmotionCache() {
  return createCache({ key: "css", prepend: true })
}
